import React from 'react';
import { useTranslation } from 'react-i18next';
import { Coins, Play, Square } from 'lucide-react';
import { useDecideApproval } from '../../../hooks/mutations';
import { CardShell, ResolvedCard, primaryBtn, secondaryBtn } from './CardShell';

const TITLE = { spent: 'bots.checkin.spent', credits: 'bots.checkin.no_credits', budget: 'bots.checkin.no_budget' };
const HINT = { spent: 'bots.checkin.spent_hint', credits: 'bots.checkin.no_credits_hint', budget: 'bots.checkin.no_budget_hint' };

/**
 * The bot asks before going on (backend agents/runtime.py, CHECKIN_CREDITS): the task used
 * more credits, or the credits or the project's monthly bot budget ran out. Its work so far
 * is kept: Continue goes on where it stopped, Stop here ends it with what it has.
 */
const CheckinCard = ({ approval, botName, compact }) => {
  const { t } = useTranslation();
  const decide = useDecideApproval();
  const { reason = 'spent', credits, next } = approval.args || {};
  const title = t(TITLE[reason] || TITLE.spent, { credits });
  if (approval.status !== 'pending') {
    const ok = approval.status === 'approved';
    return <ResolvedCard icon={Coins} text={title} ok={ok} testid="checkin-card-resolved"
      outcome={ok ? t('bots.checkin.continued') : t('bots.checkin.stopped')} />;
  }
  const act = (approve) => decide.mutate({ approvalId: approval.id, approve });
  return (
    <CardShell icon={Coins} testid="checkin-card" waiting compact={compact}
      eyebrow={t('bots.checkin.eyebrow', { bot: botName })} title={title}
      footer={(
        <>
          <span className="flex-1" />
          <button type="button" className={secondaryBtn} disabled={decide.isPending} onClick={() => act(false)}>
            <Square className="w-3.5 h-3.5" />{t('bots.checkin.stop')}
          </button>
          <button type="button" className={primaryBtn} disabled={decide.isPending} onClick={() => act(true)}>
            <Play className="w-3.5 h-3.5" />{t('bots.checkin.continue')}
          </button>
        </>
      )}>
      <p className="text-[13px] text-muted-foreground">{t(HINT[reason] || HINT.spent, { bot: botName, next })}</p>
    </CardShell>
  );
};

export default CheckinCard;
